<template>
    <span
        v-if="hasStatus(['Send', 'Sent', 'Delivery', 'Delivered'])"
        :class="templateClass"
        v-b-tooltip.hover="hasContact"
        :title="contact"
    >
        <i class="cus-email-go"></i> {{ statuses[status] }}
    </span>
    <span
        v-else-if="hasStatus(['Open', 'Opened'])"
        :class="templateClass"
        v-b-tooltip.hover="hasContact"
        :title="contact"
    >
        <i class="cus-email-open"></i> {{ statuses[status] }}
    </span>
    <span
        v-else-if="hasStatus(['Click', 'Clicked'])"
        :class="templateClass"
        v-b-tooltip.hover="hasContact"
        :title="contact"
    >
        <i class="cus-email-link"></i> {{ statuses[status] }}
    </span>
    <span
        v-else-if="
            hasStatus([
                'Bounce',
                'Bounced',
                'Fail',
                'Failed',
                'Rendering Failed',
                'renderingFailure'
            ])
        "
        :class="templateClass"
        v-b-tooltip.hover
        :title="`${contact ? `${contact} - ` : ''}${
            smtpError ? smtpError : 'Error'
        }`"
    >
        <i class="cus-email-error"></i> {{ statuses[status] }}
    </span>
    <span
        v-else-if="hasStatus(['Complaint', 'Reject', 'Rejected'])"
        :class="templateClass"
        v-b-tooltip.hover="hasContact"
        :title="contact"
    >
        <i class="cus-email-delete"></i> {{ statuses[status] }}
    </span>
</template>

<script>
import { isEmpty } from "lodash";

export default {
    props: {
        status: {
            type: String
        },
        contact: {
            type: String
        },
        smtpError: {
            type: String
        }
    },
    data() {
        return {
            templateClass:
                "d-inline-flex justify-content-start align-items-center text-nowrap"
        };
    },
    computed: {
        statuses() {
            // Looking at the status in the database and backend, we only handle -
            // Send, Delivery, Open, Click, Bounce, renderingFailure, Complaint, Reject.
            // But some places handle the status as Sent, Delivered, Opened, Clicked, Bounced, Complained, Rejected.
            // Just to be safe, we'll handle all of them.
            return {
                Send: "Sent",
                Sent: "Sent",
                Delivery: "Delivered",
                Delivered: "Delivered",
                Open: "Opened",
                Opened: "Opened",
                Click: "Clicked",
                Clicked: "Clicked",
                Bounce: "Failed",
                Bounced: "Failed",
                Fail: "Failed",
                Failed: "Failed",
                renderingFailure: "Rendering Failed",
                "Rendering Failed": "Rendering Failed",
                Complaint: "Complaint",
                Reject: "Rejected",
                Rejected: "Rejected"
            };
        },
        hasContact() {
            return !isEmpty(this.contact);
        }
    },
    methods: {
        hasStatus(status) {
            if (!this.status) {
                return false;
            } else if (typeof status === "string") {
                return this.status === status;
            } else if (Array.isArray(status)) {
                return status.some(key => this.status === key);
            } else {
                return false;
            }
        }
    }
};
</script>
